/* eslint-disable */
import { DataGrid, GridToolbar } from '@mui/x-data-grid'
import { LinearProgress, Typography } from '@mui/material'
import '../../globalStyle.scss'
import { useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'

function BreachDataList({ isLoading, data }: any) {
  const navigate = useNavigate()
  const columns = [
    {
      field: 'id',
      headerName: 'ID',
      flex: 0.5,
      renderCell: (params: any) => (
        <div
          className='linkStyle'
          onClick={() => {
            navigate(`/breachManagement/breachManagementDetails`, {
              state: { breachId: params.value, breachName: params.row.breachName },
            })
          }}
        >
          {params.value}
        </div>
      ),
    },
    { field: 'breachName', headerName: 'Breach Name', flex: 1.5 },
    {
      field: 'reportDate',
      headerName: 'Report Date',
      flex: 1,
      valueFormatter: (params: any) => {
        return dayjs(params.value).format('YYYY-MM-DD')
      },
    },
    {
      field: 'openDate',
      headerName: 'Open Date',
      flex: 1,
      valueFormatter: (params: any) => {
        return dayjs(params.value).format('YYYY-MM-DD')
      },
    },
    { field: 'severity', headerName: 'Severity', flex: 1 },
    { field: 'status', headerName: 'Status', flex: 1 },
  ]

  return (
    <>
      <DataGrid
        loading={isLoading}
        hideFooterSelectedRowCount
        slots={{
          loadingOverlay: LinearProgress,
          toolbar: GridToolbar,
        }}
        slotProps={{
          toolbar: {
            showQuickFilter: false,
          },
        }}
        columns={columns}
        rows={data?.data || []}
        sx={{
          border: 0,
          '& .MuiDataGrid-row:hover': {
            backgroundColor: 'rgba(235, 235, 235, 0.7)',
          },
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#FFFFFF',
            color: '#5B5B5B',
            fontSize: '15px',
            fontFamily: 'Segoe UI',
            borderBottom: '2px solid #BABABA',
          },
          '& .MuiDataGrid-cell': {
            borderBottom: `1px solid #BABABA`,
            fontSize: '12px',
            cursor: 'pointer',
            fontFamily: 'Segoe UI',
            fontWeight: '600',
          },
          '& .MuiDataGrid-columnSeparator': {
            display: 'none',
          },
          '& ::-webkit-scrollbar': {
            width: '5px',
          },
          '& ::-webkit-scrollbar-track': {
            backgroundColor: '#f1f1f1',
          },
          '& ::-webkit-scrollbar-thumb': {
            backgroundColor: '#888',
            borderRadius: '5px',
            '&:hover': {
              backgroundColor: '#555',
            },
          },
          '& .MuiDataGrid-toolbarContainer .MuiButtonBase-root': {
            color: '#5B5B5B',
          },
          '& .MuiDataGrid-toolbarContainer .MuiSvgIcon-root': {
            fill: '#5B5B5B',
          },
        }}
      />
    </>
  )
}

export default BreachDataList
